export interface VersionResponseModel {
  version: string;
  databaseversion: string;
  apiVersion: string;
}
